import inputMagic from './inputMagic'
import normal from './normal'
import baseMagic from './baseMagic'

export default {
  normal,
  baseMagic,
  inputMagic
}
